export const skillsData: Record<string, string[]> = {
  'Languages': ['JavaScript', 'TypeScript', 'Python', 'Java', 'C#', 'React', 'Node JS', 'SQL', 'Xml', 'Json', 'YAML', 'Unix/Linux', 'Html', 'CSS'],
  'Development Tools': ['Kiro', 'Q Developer', 'VS Code', 'Eclipse', 'IntelliJ'],
  'Quality Assurance Automation Tools': ['Playwright', 'AccelQ', 'Selenium', 'Cucumber', 'QTP/UFT', 'Rest-Assured', 'SoapUI', 'Postman', 'JMeter', 'LoadRunner'],
  'AWS': ['EC2', 'S3', 'Lambda', 'DynamoDB', 'RDS', 'CloudFormation', 'Bedrock'],
  'API': ['REST', 'SOAP', 'GraphQL'],
  'Database': ['SQL Server Management Studio', 'Oracle SQL Developer', 'MySQL', 'Snowflake', 'MongoDB', 'Looker'],
  'DevOps': ['Git', 'CI/CD', 'GitHub Actions', 'Azure', 'Copado', 'Jenkins', 'Terraform', 'Docker', 'Kubernetes'],
  'AI Concepts': ['Retrieval Augmented Generation (RAG)', 'Model Context Protocol (MCP)', 'Large Language Models (LLMs)', 'Neural Networks', 'Generative AI', 'Agentic AI'],
  'Lifecycle Management': ['Jira', 'Confluence', 'Quality Center/ALM', 'Trello', 'Team Foundation Server'],
  'Certifications': ['AWS Certified Developer - Associate', 'AWS Certified AI Practitioner', 'AWS Certified Cloud Practitioner', 'Certified Software Test Professional Associate Level']
};

export function getFilteredSkills(searchTerm: string, data: Record<string, string[]>): Record<string, string[]> {
  if (!searchTerm) return data;

  const filtered: Record<string, string[]> = {};
  Object.entries(data).forEach(([category, skills]) => {
    const matchingSkills = skills.filter(skill =>
      skill.toLowerCase().includes(searchTerm)
    );
    if (matchingSkills.length > 0) {
      filtered[category] = matchingSkills;
    }
  });
  return filtered;
}
